// import React, { useState, useEffect } from "react";
// import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";

// const StatsCard = ({
//   title,
//   subtitle,
//   value,
//   growth,
//   growthText,
//   lastUpdate,
//   lastUpdateValue,
//   valueColor = "#8b5cf6",
//   loading = false,
// }) => (
//   <Paper
//     elevation={0}
//     sx={{
//       p: { xs: 2, sm: 2.5, md: 3, xl: 3 },
//       borderRadius: 2,
//       backgroundColor: "#fff",
//       width: { xs: "100%", sm: "100%", md: "100%", xl: "457px" },
//       minWidth: { xs: "315px", sm: "320px", md: "380px" },
//       minHeight: { xs: "160px", sm: "170px", md: "180px", xl: "auto" },
//       display: "flex",
//       flexDirection: "column",
//     }}
//   >
//     {/* Header Section */}
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//         mb: { xs: 1.5, sm: 1.5, md: 2, xl: 2 },
//         flexDirection: { xs: "column", sm: "row" },
//         gap: { xs: 0.5, sm: 0 },
//       }}
//     >
//       <Typography
//         variant="body2"
//         sx={{
//           fontSize: { xs: "15px", sm: "16px", md: "17px", xl: "17px" },
//           fontWeight: 500,
//           color: "#374151",
//           lineHeight: 1.2,
//           fontFamily: "Outfit",
//         }}
//       >
//         {title}
//       </Typography>

//       <Typography
//         variant="caption"
//         sx={{
//           fontSize: { xs: "12px", sm: "13px", md: "14px", xl: "14px" },
//           color: "#9ca3af",
//           whiteSpace: "nowrap",
//           fontFamily: "Outfit",
//           fontWeight: 400,
//           ml: { xs: 0, sm: 1 },
//         }}
//       >
//         {subtitle}
//       </Typography>
//     </Box>

//     {/* Value Section */}
//     <Box sx={{ mb: { xs: 1.5, sm: 1.5, md: 2, xl: 2 } }}>
//       {loading ? (
//         <Box sx={{ display: "flex", alignItems: "center", height: "2.5rem" }}>
//           <CircularProgress size={24} sx={{ color: valueColor }} />
//         </Box>
//       ) : (
//         <Typography
//           variant="h1"
//           sx={{
//             color: valueColor,
//             fontSize: { xs: "2rem", sm: "2.2rem", md: "2.4rem", xl: "2.5rem" },
//             lineHeight: 1,
//             textAlign: "left",
//             fontFamily: "Outfit",
//             fontWeight: 700,
//             mb: { xs: "-2%", sm: "0", md: "0", xl: "-5%" },
//           }}
//         >
//           {value}
//         </Typography>
//       )}
//     </Box>

//     {/* Bottom Section */}
//     <Box sx={{ mt: "auto", pt: 1 }}>
//       {/* Growth section or Last update section */}
//       {growth ? (
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: { xs: "flex-start", sm: "center" },
//             gap: { xs: 0.5, sm: 0.8, xl: 0.8 },
//             flexDirection: { xs: "column", sm: "row" },
//             mt: 0,
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               color: "#05CD99",
//               fontFamily: "Outfit",
//               fontWeight: 700,
//               fontSize: { xs: "14px", sm: "15px", md: "16px", xl: "16px" },
//             }}
//           >
//             {growth}
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               fontSize: { xs: "13px", sm: "14px", md: "15px", xl: "15px" },
//               color: "#A3AED0",
//               fontFamily: "Outfit",
//               fontWeight: 400,
//               lineHeight: 1.3,
//             }}
//           >
//             {growthText}
//           </Typography>
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             flexDirection: { xs: "column", sm: "column", md: "row" },
//             gap: { xs: 1.5, sm: 1.5, md: 0 },
//             alignItems: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               fontSize: { xs: "13px", sm: "14px", md: "15px", xl: "15px" },
//               color: "#A3AED0",
//               fontFamily: "Outfit",
//               fontWeight: 400,
//               lineHeight: 1.3,
//               flex: { xs: "none", sm: "none", md: "none" },
//             }}
//           >
//             {growthText}
//           </Typography>
//           <Box
//             sx={{
//               textAlign: { xs: "left", md: "right" },
//               minWidth: { xs: "auto", md: "80px" },
//             }}
//           >
//             <Typography
//               variant="caption"
//               sx={{
//                 fontSize: { xs: "12px", sm: "13px", md: "14px", xl: "15px" },
//                 color: "#A3AED0",
//                 fontFamily: "Outfit",
//                 fontWeight: 400,
//                 display: "block",
//                 mb: 0.5,
//                 lineHeight: 1.2,
//               }}
//             >
//               {lastUpdate}
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontSize: { xs: "18px", sm: "20px", md: "22px", xl: "25px" },
//                 color: "#9048FB",
//                 fontFamily: "Outfit",
//                 fontWeight: 700,
//                 lineHeight: 1,
//               }}
//             >
//               {loading ? (
//                 <CircularProgress size={16} sx={{ color: "#9048FB" }} />
//               ) : (
//                 lastUpdateValue
//               )}
//             </Typography>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   </Paper>
// );

// export default function StatsGridThree() {
//   const [statsData, setStatsData] = useState([
//     {
//       title: "Total Job Postings",
//       subtitle: "Updated Wed, January",
//       value: "0",
//       growth: "+23%",
//       growthText: "compared to last month",
//       valueColor: "#8b5cf6",
//     },
//     {
//       title: "Total Resumes Screen",
//       subtitle: "Updated Wed, January",
//       value: "0",
//       growth: "",
//       growthText: "7 companies are not active",
//       lastUpdate: "Last month",
//       lastUpdateValue: "0",
//       valueColor: "#8b5cf6",
//     },
//     {
//       title: "Total Interviews Conducted",
//       subtitle: "Updated Wed, January",
//       value: "0",
//       growth: "+23%",
//       growthText: "registrations over the past six months",
//       valueColor: "#8b5cf6",
//     },
//   ]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Function to fetch data from API
//   const fetchJobResumeStats = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(
//         "http://localhost:3000/super-admin/job-resume-stats"
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch data");
//       }

//       const result = await response.json();

//       if (result.success) {
//         const apiData = result.data;

//         // Create stats array with API data (hardcoded subtitle as requested)
//         const formattedStats = [
//           {
//             title: "Total Job Postings",
//             subtitle: "",
//             value: apiData.TotalJobPostings.toString(),
//             growth: "",
//             growthText: "",
//             valueColor: "#8b5cf6",
//           },
//           {
//             title: "Total Resumes Screen",
//             subtitle: "",
//             value: apiData.TotalResumesScreened.toString(),
//             growth: "",
//             growthText: "",
//             lastUpdate: "",
//             lastUpdateValue: "",
//             valueColor: "#8b5cf6",
//           },
//           {
//             title: "Total Interviews Conducted",
//             subtitle: "",
//             value: apiData.TotalinterviewConductedCount.toString(),
//             growth: "",
//             growthText: "",
//             valueColor: "#8b5cf6",
//           },
//         ];

//         setStatsData(formattedStats);
//       } else {
//         throw new Error(result.message || "Failed to fetch stats");
//       }
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching job resume stats:", err);

//       // Keep the default data with 0 values on error
//       setStatsData([
//         {
//           title: "Total Job Postings",
//           subtitle: "Updated Wed, January",
//           value: "127",
//           growth: "+23%",
//           growthText: "compared to last month",
//           valueColor: "#8b5cf6",
//         },
//         {
//           title: "Total Resumes Screen",
//           subtitle: "Updated Wed, January",
//           value: "120",
//           growth: "",
//           growthText: "7 companies are not active",
//           lastUpdate: "Last month",
//           lastUpdateValue: "27",
//           valueColor: "#8b5cf6",
//         },
//         {
//           title: "Total Interviews Conducted",
//           subtitle: "Updated Wed, January",
//           value: "27",
//           growth: "+23%",
//           growthText: "registrations over the past six months",
//           valueColor: "#8b5cf6",
//         },
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchJobResumeStats();
//   }, []);

//   if (error) {
//     return (
//       <Box
//         sx={{
//           p: { xs: 2, sm: 3, md: 4, xl: 4 },
//           backgroundColor: "#fff",
//           ml: { xs: "0px", sm: "0px", md: "100px", xl: "200px" },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           minHeight: "300px",
//         }}
//       >
//         <Typography variant="h6" sx={{ fontFamily: "Outfit", color: "red" }}>
//           Error: {error}
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         p: { xs: 2, sm: 3, md: 4, xl: 4 },
//         backgroundColor: "#fff",
//         ml: { xs: "0px", sm: "0px", md: "100px", xl: "200px" },
//       }}
//     >
//       <Box sx={{ mx: "auto" }}>
//         <Grid
//           container
//           spacing={{ xs: 2, sm: 2.5, md: 3, xl: 3 }}
//           sx={{ display: "flex", flexWrap: "wrap" }}
//         >
//           {statsData.map((stat, index) => (
//             <Grid
//               item
//               xs={12}
//               sm={12}
//               md={6}
//               lg={4}
//               xl={4}
//               key={index}
//               sx={{ display: "flex" }}
//             >
//               <StatsCard {...stat} loading={loading} />
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     </Box>
//   );
// }
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";
// import { fetchJobResumeStats } from "../redux/slices/jobResumeStatsSlice";

// const StatsCard = ({
//   title,
//   subtitle,
//   value,
//   growth,
//   growthText,
//   lastUpdate,
//   lastUpdateValue,
//   valueColor = "#8b5cf6",
//   loading = false,
// }) => (
//   <Paper
//     elevation={0}
//     sx={{
//       p: { xs: 2, sm: 2.5, md: 3, xl: 3 },
//       borderRadius: 2,
//       backgroundColor: "#fff",
//       width: { xs: "100%", sm: "100%", md: "100%", xl: "457px" },
//       minWidth: { xs: "315px", sm: "320px", md: "380px" },
//       minHeight: { xs: "160px", sm: "170px", md: "180px", xl: "auto" },
//       display: "flex",
//       flexDirection: "column",
//       border: "1px solid #e5e7eb",
//     }}
//   >
//     {/* Header Section */}
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//         mb: { xs: 1.5, sm: 1.5, md: 2, xl: 2 },
//         flexDirection: { xs: "column", sm: "row" },
//         gap: { xs: 0.5, sm: 0 },
//       }}
//     >
//       <Typography
//         variant="body2"
//         sx={{
//           fontSize: { xs: "15px", sm: "16px", md: "17px", xl: "17px" },
//           fontWeight: 500,
//           color: "#374151",
//           lineHeight: 1.2,
//           fontFamily: "Outfit",
//         }}
//       >
//         {title}
//       </Typography>

//       <Typography
//         variant="caption"
//         sx={{
//           fontSize: { xs: "12px", sm: "13px", md: "14px", xl: "14px" },
//           color: "#9ca3af",
//           whiteSpace: "nowrap",
//           fontFamily: "Outfit",
//           fontWeight: 400,
//           ml: { xs: 0, sm: 1 },
//         }}
//       >
//         {subtitle}
//       </Typography>
//     </Box>

//     {/* Value Section */}
//     <Box sx={{ mb: { xs: 1.5, sm: 1.5, md: 2, xl: 2 } }}>
//       {loading ? (
//         <Box sx={{ display: "flex", alignItems: "center", height: "2.5rem" }}>
//           <CircularProgress size={24} sx={{ color: valueColor }} />
//         </Box>
//       ) : (
//         <Typography
//           variant="h1"
//           sx={{
//             color: valueColor,
//             fontSize: { xs: "2rem", sm: "2.2rem", md: "2.4rem", xl: "2.5rem" },
//             lineHeight: 1,
//             textAlign: "left",
//             fontFamily: "Outfit",
//             fontWeight: 700,
//             mb: { xs: "-2%", sm: "0", md: "0", xl: "-5%" },
//           }}
//         >
//           {value}
//         </Typography>
//       )}
//     </Box>

//     {/* Bottom Section */}
//     <Box sx={{ mt: "auto", pt: 1 }}>
//       {/* Growth section or Last update section */}
//       {growth ? (
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: { xs: "flex-start", sm: "center" },
//             gap: { xs: 0.5, sm: 0.8, xl: 0.8 },
//             flexDirection: { xs: "column", sm: "row" },
//             mt: 0,
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               color: "#05CD99",
//               fontFamily: "Outfit",
//               fontWeight: 700,
//               fontSize: { xs: "14px", sm: "15px", md: "16px", xl: "16px" },
//             }}
//           >
//             {growth}
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               fontSize: { xs: "13px", sm: "14px", md: "15px", xl: "15px" },
//               color: "#A3AED0",
//               fontFamily: "Outfit",
//               fontWeight: 400,
//               lineHeight: 1.3,
//             }}
//           >
//             {growthText}
//           </Typography>
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             flexDirection: { xs: "column", sm: "column", md: "row" },
//             gap: { xs: 1.5, sm: 1.5, md: 0 },
//             alignItems: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               fontSize: { xs: "13px", sm: "14px", md: "15px", xl: "15px" },
//               color: "#A3AED0",
//               fontFamily: "Outfit",
//               fontWeight: 400,
//               lineHeight: 1.3,
//               flex: { xs: "none", sm: "none", md: "none" },
//             }}
//           >
//             {growthText}
//           </Typography>
//           <Box
//             sx={{
//               textAlign: { xs: "left", md: "right" },
//               minWidth: { xs: "auto", md: "80px" },
//             }}
//           >
//             <Typography
//               variant="caption"
//               sx={{
//                 fontSize: { xs: "12px", sm: "13px", md: "14px", xl: "15px" },
//                 color: "#A3AED0",
//                 fontFamily: "Outfit",
//                 fontWeight: 400,
//                 display: "block",
//                 mb: 0.5,
//                 lineHeight: 1.2,
//               }}
//             >
//               {lastUpdate}
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 fontSize: { xs: "18px", sm: "20px", md: "22px", xl: "25px" },
//                 color: "#9048FB",
//                 fontFamily: "Outfit",
//                 fontWeight: 700,
//                 lineHeight: 1,
//               }}
//             >
//               {loading ? (
//                 <CircularProgress size={16} sx={{ color: "#9048FB" }} />
//               ) : (
//                 lastUpdateValue
//               )}
//             </Typography>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   </Paper>
// );

// export default function StatsGridThree() {
//   const dispatch = useDispatch();

//   // Get data from Redux store
//   const { data, loading, error } = useSelector((state) => state.jobResumeStats);

//   // Format stats data from Redux state
//   const statsData = [
//     {
//       title: "Total Job Postings",
//       subtitle: "",
//       value: data.TotalJobPostings.toString(),
//       growth: "",
//       growthText: "",
//       valueColor: "#8b5cf6",
//     },
//     {
//       title: "Total Resumes Screen",
//       subtitle: "",
//       value: data.TotalResumesScreened.toString(),
//       growth: "",
//       growthText: "",
//       lastUpdate: "",
//       lastUpdateValue: "",
//       valueColor: "#8b5cf6",
//     },
//     {
//       title: "Total Interviews Conducted",
//       subtitle: "",
//       value: data.TotalinterviewConductedCount.toString(),
//       growth: "",
//       growthText: "",
//       valueColor: "#8b5cf6",
//     },
//   ];

//   // Fetch data on component mount
//   useEffect(() => {
//     dispatch(fetchJobResumeStats());
//   }, [dispatch]);

//   if (error) {
//     return (
//       <Box
//         sx={{
//           p: { xs: 2, sm: 3, md: 4, xl: 4 },
//           backgroundColor: "#fff",
//           ml: { xs: "0px", sm: "0px", md: "100px", xl: "200px" },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           minHeight: "300px",
//         }}
//       >
//         <Typography variant="h6" sx={{ fontFamily: "Outfit", color: "red" }}>
//           Error: {error}
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         p: { xs: 2, sm: 3, md: 4, xl: 4 },
//         backgroundColor: "#fff",
//         ml: { xs: "0px", sm: "0px", md: "100px", xl: "200px" },
//       }}
//     >
//       <Box sx={{ mx: "auto" }}>
//         <Grid
//           container
//           spacing={{ xs: 2, sm: 2.5, md: 3, xl: 3 }}
//           sx={{ display: "flex", flexWrap: "wrap" }}
//         >
//           {statsData.map((stat, index) => (
//             <Grid
//               item
//               xs={12}
//               sm={12}
//               md={6}
//               lg={4}
//               xl={4}
//               key={index}
//               sx={{ display: "flex" }}
//             >
//               <StatsCard {...stat} loading={loading} />
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     </Box>
//   );
// }

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { fetchJobResumeStats } from "../redux/slices/jobResumeStatsSlice";

const StatsCard = ({
  title,
  subtitle,
  value,
  growth,
  growthText,
  lastUpdate,
  lastUpdateValue,
  valueColor = "#8b5cf6",
  loading = false,
}) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2, sm: 2.5, md: 3, xl: 3 },
      borderRadius: 2,
      backgroundColor: "#fff",
      width: { xs: "100%", sm: "100%", md: "100%", xl: "457px" },
      minWidth: { xs: "315px", sm: "320px", md: "380px" },
      minHeight: { xs: "160px", sm: "170px", md: "180px", xl: "auto" },
      display: "flex",
      flexDirection: "column",
      border: "1px solid #e5e7eb",
    }}
  >
    {/* Header Section */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: { xs: 1.5, sm: 1.5, md: 2, xl: 2 },
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 0.5, sm: 0 },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: "15px", sm: "16px", md: "17px", xl: "17px" },
          fontWeight: 500,
          color: "#374151",
          lineHeight: 1.2,
          fontFamily: "Outfit",
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="caption"
        sx={{
          fontSize: { xs: "12px", sm: "13px", md: "14px", xl: "14px" },
          color: "#9ca3af",
          whiteSpace: "nowrap",
          fontFamily: "Outfit",
          fontWeight: 400,
          ml: { xs: 0, sm: 1 },
        }}
      >
        {subtitle}
      </Typography>
    </Box>

    {/* Value Section */}
    <Box sx={{ mb: { xs: 1.5, sm: 1.5, md: 2, xl: 2 } }}>
      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center", height: "2.5rem" }}>
          <CircularProgress size={24} sx={{ color: valueColor }} />
        </Box>
      ) : (
        <Typography
          variant="h1"
          sx={{
            color: valueColor,
            fontSize: { xs: "2rem", sm: "2.2rem", md: "2.4rem", xl: "2.5rem" },
            lineHeight: 1,
            textAlign: "left",
            fontFamily: "Outfit",
            fontWeight: 700,
            mb: { xs: "-2%", sm: "0", md: "0", xl: "-5%" },
          }}
        >
          {value}
        </Typography>
      )}
    </Box>

    {/* Bottom Section */}
    <Box sx={{ mt: "auto", pt: 1 }}>
      {/* Growth section or Last update section */}
      {growth ? (
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 0.5, sm: 0.8, xl: 0.8 },
            flexDirection: { xs: "column", sm: "row" },
            mt: 0,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#05CD99",
              fontFamily: "Outfit",
              fontWeight: 700,
              fontSize: { xs: "14px", sm: "15px", md: "16px", xl: "16px" },
            }}
          >
            {growth}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: "13px", sm: "14px", md: "15px", xl: "15px" },
              color: "#A3AED0",
              fontFamily: "Outfit",
              fontWeight: 400,
              lineHeight: 1.3,
            }}
          >
            {growthText}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            gap: { xs: 1.5, sm: 1.5, md: 0 },
            alignItems: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: "13px", sm: "14px", md: "15px", xl: "15px" },
              color: "#A3AED0",
              fontFamily: "Outfit",
              fontWeight: 400,
              lineHeight: 1.3,
              flex: { xs: "none", sm: "none", md: "none" },
            }}
          >
            {growthText}
          </Typography>
          <Box
            sx={{
              textAlign: { xs: "left", md: "right" },
              minWidth: { xs: "auto", md: "80px" },
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "14px", xl: "15px" },
                color: "#A3AED0",
                fontFamily: "Outfit",
                fontWeight: 400,
                display: "block",
                mb: 0.5,
                lineHeight: 1.2,
              }}
            >
              {lastUpdate}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "18px", sm: "20px", md: "22px", xl: "25px" },
                color: "#9048FB",
                fontFamily: "Outfit",
                fontWeight: 700,
                lineHeight: 1,
              }}
            >
              {loading ? (
                <CircularProgress size={16} sx={{ color: "#9048FB" }} />
              ) : (
                lastUpdateValue
              )}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  </Paper>
);

export default function StatsGridThree({ sidebarOpen = true }) {
  const dispatch = useDispatch();

  // Get data from Redux store
  const { data, loading, error } = useSelector((state) => state.jobResumeStats);

  // Format stats data from Redux state
  const statsData = [
    {
      title: "Total Job Postings",
      subtitle: "",
      value: data.TotalJobPostings.toString(),
      growth: "",
      growthText: "",
      valueColor: "#8b5cf6",
    },
    {
      title: "Total Resumes Screen",
      subtitle: "",
      value: data.TotalResumesScreened.toString(),
      growth: "",
      growthText: "",
      lastUpdate: "",
      lastUpdateValue: "",
      valueColor: "#8b5cf6",
    },
    {
      title: "Total Interviews Conducted",
      subtitle: "",
      value: data.TotalinterviewConductedCount.toString(),
      growth: "",
      growthText: "",
      valueColor: "#8b5cf6",
    },
  ];

  // Fetch data on component mount
  useEffect(() => {
    dispatch(fetchJobResumeStats());
  }, [dispatch]);

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 200 : 100;

  if (error) {
    return (
      <Box
        sx={{
          p: { xs: 2, sm: 3, md: 4, xl: 4 },
          backgroundColor: "#fff",
          ml: {
            xs: "0px",
            sm: "0px",
            md: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "300px",
        }}
      >
        <Typography variant="h6" sx={{ fontFamily: "Outfit", color: "red" }}>
          Error: {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3, md: 4, xl: 4 },
        backgroundColor: "#fff",
        ml: {
          xs: "0px",
          sm: "0px",
          md: `${sidebarWidth}px`,
          xl: `${sidebarWidth}px`,
        },
        transition: "margin-left 0.3s ease",
      }}
    >
      <Box sx={{ mx: "auto" }}>
        <Grid
          container
          spacing={{ xs: 2, sm: 2.5, md: 3, xl: 3 }}
          sx={{ display: "flex", flexWrap: "wrap" }}
        >
          {statsData.map((stat, index) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={4}
              xl={4}
              key={index}
              sx={{ display: "flex" }}
            >
              <StatsCard {...stat} loading={loading} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
